import React, { FC, ReactElement } from 'react';

import { useTranslation } from 'react-i18next';
import { Controller, UseControllerReturn, UseFormReturn } from 'react-hook-form';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';

import ConnectForm from '../../../../../common/reactHookForm/ConnectForm';
import { NetworkConfigTypes } from './NetworkConfigTypes';

const BinaryDataConfig: FC<BinaryDataConfigProps> = (): ReactElement => {
  const { t } = useTranslation();

  return (
    <ConnectForm<NetworkConfigTypes>>
      {({ control }: UseFormReturn<NetworkConfigTypes>): ReactElement => (
        <>
          <FormControl size="small">
            <InputLabel>{t('device_receive_data_binary')}</InputLabel>
            <Controller
              control={control}
              name="isReceiveDataBin"
              render={({
                field,
              }: UseControllerReturn<NetworkConfigTypes, 'isReceiveDataBin'>): ReactElement => (
                <Select<boolean>
                  {...field}
                  onChange={(event: SelectChangeEvent): void => {
                    field.onChange(event.target.value === 'true' ? true : false);
                  }}
                  label={t('device_receive_data_binary')}
                >
                  <MenuItem value="true">{t('yes')}</MenuItem>
                  <MenuItem value="false">{t('no')}</MenuItem>
                </Select>
              )}
            />
          </FormControl>

          <FormControl size="small">
            <InputLabel>{t('device_send_data_binary')}</InputLabel>
            <Controller
              control={control}
              name="isSendDataBin"
              render={({
                field,
              }: UseControllerReturn<NetworkConfigTypes, 'isSendDataBin'>): ReactElement => (
                <Select<boolean>
                  {...field}
                  onChange={(event: SelectChangeEvent): void => {
                    field.onChange(event.target.value === 'true' ? true : false);
                  }}
                  label={t('device_send_data_binary')}
                >
                  <MenuItem value="true">{t('yes')}</MenuItem>
                  <MenuItem value="false">{t('no')}</MenuItem>
                </Select>
              )}
            />
          </FormControl>
        </>
      )}
    </ConnectForm>
  );
};

export default BinaryDataConfig;

interface BinaryDataConfigProps {}
